import { render, staticRenderFns } from "./WxButton.vue?vue&type=template&id=2c2bc878"
import script from "./WxButton.vue?vue&type=script&lang=js"
export * from "./WxButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports